import styled from 'styled-components';

export const AgentsSectionStyled = styled.div`
  position: relative;
  width: 100%;

  .text-box {
    width: 100%;
    margin: 0 0 10px;
    color: var(--light-gray);

    .heading {
      display: block;
      font-size: 22px;
      line-height: 26px;
      font-weight: 800;
      margin: 0 0 10px;
      color: var(--text-color);
    }
  }
  .my-agents {
    .input-wrapper {
      @media (min-width: 992px) {
        max-width: 300px;
        margin-left: auto;
      }
    }
  }
  .feeda-agents {
    .inputs-wrapper {
      @media (min-width: 992px) {
        display: flex;
        gap: 16px;
        max-width: 500px;
        margin-left: auto;
      }

      .select-wrapper {
        width: 100%;
        margin: 0 0 10px;

        @media (min-width: 992px) {
          max-width: 200px;
        }
      }
    }
  }
  .filter-list {
    display: flex;
    gap: 10px;
    padding: 0;
    margin: 0 0 10px;

    li {
      width: 50%;
      margin: 0 0 5px;

      @media (min-width: 768px) {
        width: auto;
      }
      @media (min-width: 992px) {
        margin: 0;
      }
    }

    .btn-filter {
      display: block;
      width: 100%;
      font-size: 14px;
      line-height: 17px;
      text-transform: capitalize;
      padding: 10px 12px;
      border-radius: 10px;
      border: 1px solid rgba(157, 157, 157, 0.4);
      background: var(--gray-100);

      &:hover,
      &.active {
        border: 1px solid var(--primary);
        background: rgba(254, 221, 88, 0.3);
      }
    }
  }
`;
export const PageHeader = styled.div`
  gap: 60px;
  margin: 0 0 15px;
  font-size: 16px;
  line-height: 22px;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 5px;
  }
  @media (min-width: 1200px) {
    font-size: 18px;
  }

  .text-box {
    width: 100%;
    margin: 0 0 15px;

    @media (min-width: 768px) {
      margin: 0 0 20px;
    }
  }

  h1 {
    font-size: 25px;
    line-height: 30px;
    font-weight: 800;

    @media (min-width: 992px) {
      font-size: 32px;
      line-height: 36px;
    }
  }

  button {
    @media (max-width: 767px) {
      max-width: 100%;
    }
  }
`;

export const AgentCardHolder = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 10px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1400px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;
